import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { HpbPageDelete_HpbListPage_Mutation } from "./mutation";
import { HpbPageList_HpbPageListPage_Query } from "../../query/use-HPB-list-query/query";

type Props = {
	hotelID: string;
};

export const useHpbPageDeleteMutation = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(HpbPageDelete_HpbListPage_Mutation, {
		refetchQueries: [
			{
				query: HpbPageList_HpbPageListPage_Query,
				variables: {
					hotelID,
				},
			},
		],
	});

	const onDelete = useCallback(
		async ({ uuid }: { uuid: string }) => {
			if (!window.confirm("本当に削除しますか？")) return;

			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					hotelID,
					uuid,
				},
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					title: "ページを削除しました",
				});
			}
		},
		[hideLoadingScreenCallback, hotelID, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDelete,
	};
};
